/**
 * List default filters & sorts (Complaints / Devices preferences).
 * Values map to page filter state and server sort params.
 */

export const COMPLAINTS_STATUS_FILTER_OPTIONS = [
  { id: 'open_tickets', label: 'Open tickets' },
  { id: 'all', label: 'All statuses' },
  { id: 'open', label: 'Open' },
  { id: 'in_progress', label: 'In Progress' },
];

/** Statuses treated as open / unresolved on the Complaints list */
export const OPEN_TICKET_COMPLAINT_STATUSES = [
  'open',
  'acknowledged',
  'in_progress',
  'escalated_to_vendor',
];

export const DEVICES_FILTER_OPTIONS = [
  { id: 'all', label: 'All devices' },
  { id: 'active', label: 'Active only' },
  { id: 'active_complaints', label: 'With active complaints' },
  { id: 'in_transfer', label: 'In transfer' },
  { id: 'overdue_ppm', label: 'Overdue PPM' },
];

export const COMPLAINTS_SORT_OPTIONS = [
  { id: 'created_at_desc', label: 'Newest first', sort_by: 'created_at', sort_direction: 'desc' },
  { id: 'updated_at_desc', label: 'Recently updated', sort_by: 'updated_at', sort_direction: 'desc' },
  { id: 'severity_asc', label: 'Priority (critical first)', sort_by: 'severity', sort_direction: 'asc' },
];

export const DEVICES_SORT_OPTIONS = [
  { id: 'updated_at_desc', label: 'Recently updated', sort_by: 'updated_at', sort_direction: 'desc' },
  { id: 'name_asc', label: 'Name (A–Z)', sort_by: 'name', sort_direction: 'asc' },
];

export const DEFAULT_COMPLAINTS_STATUS_FILTER = 'open_tickets';

/** Server default for Maintenance History / My Work Logs when no date range is sent */
export const MAINTENANCE_LIST_DEFAULT_LOOKBACK_DAYS = 45;
export const DEFAULT_DEVICES_FILTER = 'all';
export const DEFAULT_COMPLAINTS_SORT = 'created_at_desc';
export const DEFAULT_DEVICES_SORT = 'updated_at_desc';

export function isValidComplaintsStatusFilter(id) {
  return COMPLAINTS_STATUS_FILTER_OPTIONS.some((o) => o.id === id);
}

export function isValidDevicesFilter(id) {
  return DEVICES_FILTER_OPTIONS.some((o) => o.id === id);
}

export function isValidComplaintsSort(id) {
  return COMPLAINTS_SORT_OPTIONS.some((o) => o.id === id);
}

export function isValidDevicesSort(id) {
  return DEVICES_SORT_OPTIONS.some((o) => o.id === id);
}

/** Map preference → complaint statuses array (empty = all). */
export function statusesFromComplaintsStatusFilter(pref) {
  switch (pref) {
    case 'open_tickets':
      return [...OPEN_TICKET_COMPLAINT_STATUSES];
    case 'open':
      return ['open'];
    case 'in_progress':
      return ['in_progress'];
    case 'all':
    default:
      return [];
  }
}

/**
 * Apply devices default-filter preference onto a fresh filter state object.
 * Mutates a copy; does not touch unrelated keys.
 */
export function applyDevicesFilterPreference(pref, baseFilters) {
  const next = { ...baseFilters };
  switch (pref) {
    case 'active':
      next.deviceStatus = ['active'];
      break;
    case 'active_complaints':
      next.hasActiveComplaints = true;
      next.hasNoActiveComplaints = false;
      next.impactsAvailability = '';
      break;
    case 'in_transfer':
      next.deviceStatus = ['in_transfer'];
      break;
    case 'overdue_ppm':
      next.ppmStatus = ['Overdue (0-30d)', 'Overdue (30+d)'];
      break;
    case 'all':
    default:
      break;
  }
  return next;
}

export function sortingFromComplaintsSort(pref) {
  const opt = COMPLAINTS_SORT_OPTIONS.find((o) => o.id === pref)
    || COMPLAINTS_SORT_OPTIONS.find((o) => o.id === DEFAULT_COMPLAINTS_SORT);
  return { sort_by: opt.sort_by, sort_direction: opt.sort_direction };
}

export function sortingFromDevicesSort(pref) {
  const opt = DEVICES_SORT_OPTIONS.find((o) => o.id === pref)
    || DEVICES_SORT_OPTIONS.find((o) => o.id === DEFAULT_DEVICES_SORT);
  return { sort_by: opt.sort_by, sort_direction: opt.sort_direction };
}
